export default {
  navigation: {
    next: "आगे",
    back: "पीछे",
    surveyNavigation: "सर्वेक्षण नेविगेशन",
    workspace: {
      home: "मुखपृष्ठ",
      example: "उदाहरण"
    }
  }
}
